<template>
	<v-container>
		<div class="navbar" :class="{ 'navbar--select': !planSelected }">
			<router-link
				class="navbar__logo"
				v-if="planSelected && dashBoardPath"
				:to="dashBoardPath"
				@click="goToDashboard"
			>
				<img alt="" class="logo" src="@/assets/logo-small.svg" />
				<span class="d-sr-only">Back to the dashboard</span>
			</router-link>
			<div
				:class="`links-window ${showDrawer ? 'js-active' : ''}`"
				@click.self="showDrawer = false"
			>
				<div class="links-container">
					<div
						class="d-lg-none d-flex py-4 px-8"
						:class="[planSelected === true ? 'justify-space-between' : 'justify-end']"
					>
						<router-link
							v-if="planSelected && dashBoardPath"
							:to="dashBoardPath"
							@click="goToDashboard"
						>
							<img alt="" class="logo" src="@/assets/logo-small.svg" />
							<span class="d-sr-only">Back to the dashboard</span>
						</router-link>
						<button class="btn-plain close-menu" @click="showDrawer = false">
							<v-icon icon="mdi-close" />
						</button>
					</div>
					<div class="links" v-if="planSelected">
						<v-list-item :to="dashBoardPath" @click="goToDashboard" :active="false">
							Home
						</v-list-item>
						<div class="dropdown-link" v-if="careLinks.filter((x) => x.enabled).length > 0">
							<v-list-item @click="toggleCareDropdown" @focus="dropdownFocus">
								Care
								<v-icon :icon="careDropdown ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
							</v-list-item>
							<div v-show="careDropdown" @mouseleave="careDropdown = false" class="dropdown">
								<v-list-item
									v-for="link in careLinks.filter((x) => x.enabled)"
									@click="routeTo(link.link)"
								>
									<span class="custom-icon" v-if="link.iconCustom">
										<img :src="IconPillBottle" />
									</span>
									<v-icon v-else :icon="'mdi-' + link.icon" />
									{{ link.title }}
								</v-list-item>
							</div>
						</div>
						<v-list-item
							to="/payment-center"
							@click="closeMenus"
							v-if="
								rightsStore?.payBill ||
								(!rightsStore?.payBill &&
									rightsStore?.pageIdentifiers?.some((x) => x.type == 'medicarePayment'))
							"
							:active="false"
						>
							Pay Bill
						</v-list-item>
						<v-list-item
							to="/id-card"
							@click="closeMenus"
							v-if="rightsStore?.idCards"
							:active="false"
						>
							ID Card
						</v-list-item>
						<v-list-item
							to="/programs"
							@click="closeMenus"
							v-if="rightsStore?.programs?.length"
							:active="false"
						>
							Programs
						</v-list-item>
						<div v-show="policyLinks.filter((x) => x.enabled).length > 0" class="dropdown-link">
							<v-list-item @click="togglePolicyDropdown" @focus="dropdownFocus">
								Policy
								<v-icon :icon="policyDropdown ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
							</v-list-item>
							<div
								v-show="policyDropdown"
								@mouseleave="policyDropdown = false"
								class="dropdown policy"
							>
								<v-list-item
									v-for="link in policyLinks.filter((x) => x.enabled)"
									@click="routeTo(link.link)"
								>
									<v-icon :icon="'mdi-' + link.icon" />
									{{ link.title }}
								</v-list-item>
							</div>
						</div>
						<v-list-item
							to="/pharmacy"
							@click="closeMenus"
							v-if="rightsStore?.pharmacyCenter || rightsStore?.rxSavingsSolutions"
							:active="false"
						>
							Pharmacy
						</v-list-item>
						<v-list-item
							to="/documents"
							@click="closeMenus"
							v-if="rightsStore?.forms"
							:active="false"
						>
							Documents
						</v-list-item>
						<v-list-item to="/contact-us" @click="closeMenus" :active="false">
							Contact Us
						</v-list-item>
					</div>
					<div v-else></div>

					<div class="d-block d-lg-flex">
						<NotificationBell class="d-none d-lg-flex" v-if="planSelected" />
						<div class="profile">
							<v-btn
								icon="mdi-account-outline"
								class="profile-btn"
								@click="showProfile = !showProfile"
								variant="text"
								aria-label="Profile Button"
							/>
							<div
								class="profile-panel"
								v-show="showProfile || showDrawer"
								@mouseleave="showProfile = false"
							>
								<div class="heading">
									<div>
										<p>{{ greeting }},</p>
										<p class="font-weight-medium">{{ displayName }}</p>
									</div>
								</div>
								<div class="body" v-if="planSelected">
									<h4>{{ planName }}</h4>
									<div class="row">
										<p class="secondary">Member ID:</p>
										<p class="font-weight-medium">{{ memberId }}</p>
									</div>
									<div class="row">
										<p class="secondary">Start Date:</p>
										<p class="font-weight-medium">{{ startDate }}</p>
									</div>
									<v-btn
										v-if="showSwitchPlans"
										variant="text"
										class="link mt-1"
										@click="closeMenus"
										to="/select-plan"
										>Switch Plans</v-btn
									>
								</div>
								<v-list-item
									class="settings fullsize"
									width="100%"
									height="44"
									v-if="planSelected"
									:active="false"
									to="/settings"
									@click="closeMenus"
								>
									<v-icon icon="mdi-cog-outline" class="me-2" />
									Settings
								</v-list-item>
								<v-list-item
									class="fullsize"
									width="100%"
									height="44"
									@click="clickedLogout"
									@focusout="showProfile = false"
								>
									<v-icon icon="mdi-logout" class="me-2" />
									Sign Out
								</v-list-item>
							</div>
							<v-btn
								class="d-lg-none secondary mt-5"
								width="100%"
								height="44"
								variant="outlined"
								v-if="planSelected"
								to="/settings"
								:active="false"
								@click="closeMenus"
							>
								<v-icon icon="mdi-cog-outline" class="me-2" />
								Settings
							</v-btn>
							<v-btn
								class="d-lg-none secondary"
								width="100%"
								height="44"
								variant="outlined"
								@click="clickedLogout"
							>
								Sign Out
								<v-icon icon="mdi-logout" class="ms-2" />
							</v-btn>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex">
				<NotificationBell class="d-lg-none" v-if="planSelected" />
				<button
					class="d-lg-none btn-plain"
					@click="maintainFocus"
					aria-label="Mobile Navigation Menu"
				>
					<v-icon icon="mdi-menu" class="menu" />
				</button>
			</div>
		</div>
	</v-container>
</template>

<script lang="ts">
import IconPillBottle from '@/assets/icons/icon-pill-bottle.svg'
import { logout } from '@/services/api/apiAuthHelpers.ts'
import { ssoBridge } from '@/services/sso/ssoBridge.ts'
import { useAccessRightsStore } from '../stores/accessRights/accessRights.ts'
import { useSelectedPlanStore } from '@/stores/plans/selectedPlan.ts'
import { useMembershipsStore } from '@/stores/userInfo/memberships.js'
import { useUserSettingsStore } from '@/stores/settings/userSettings.ts'
import { MMDDYYYY } from '@/utils/utils.js'
import { storeToRefs } from 'pinia'
import NotificationBell from '@/components/NotificationBell.vue'
import {
	confirmContinue,
	hasPendingChanges,
	hasSignOutClicked
} from '@/composables/userState.comp.ts'
import { checkCarrierCode } from '@/utils/globalVars.ts'

interface NavLink {
	icon: string
	iconCustom?: boolean
	title: string
	link: string | { app: string }
	enabled: boolean
}

export default {
	components: { NotificationBell },
	data() {
		return {
			IconPillBottle,
			careDropdown: false,
			policyDropdown: false,
			showProfile: false,
			showDrawer: false,
			planSelected: false,
			careLinks: [
				{
					icon: 'text-box-outline',
					title: 'Claims',
					link: '/medical-claims',
					enabled: false
				},
				{
					icon: 'text-box-multiple-outline',
					title: 'Explanation of Benefits',
					link: '/eobs',
					enabled: false
				},
				{
					icon: 'icon-pill-bottle',
					iconCustom: true,
					title: 'Pharmacy Spending',
					link: '/pharmacy-spending',
					enabled: false
				},
				{
					icon: 'chart-pie-outline',
					title: 'Spending Details',
					link: '/spending-details',
					enabled: false
				},
				{
					icon: 'card-account-details-outline',
					title: 'Personal Health Record',
					link: '/health-records',
					enabled: false
				},
				{
					icon: 'swap-horizontal',
					title: 'Health Reimbursement Account',
					link: '/health-reimbursement',
					enabled: false
				},
				{
					icon: 'magnify',
					title: 'Find Care & Costs',
					link: '/find-care',
					enabled: false
				},
				{
					icon: 'calendar-check',
					title: 'Preventive Wellness Services',
					link: '/preventive-wellness',
					enabled: false
				}
			] as NavLink[],
			policyLinks: [
				{
					icon: 'shield-check-outline',
					title: 'Coverage & Copays',
					link: '/coverage-and-copays',
					enabled: false
				},
				{
					icon: 'shield-check-outline',
					title: 'Coverage & Benefits',
					link: '/dental/coverage-and-benefits',
					enabled: false
				},
				{
					icon: 'shield-check-outline',
					title: 'Coverage',
					link: '/vision/coverage',
					enabled: false
				},
				{
					icon: 'stethoscope',
					title: 'Primary Care Provider',
					link: '/primary-care-provider',
					enabled: false
				},
				{
					icon: 'file-document-arrow-right-outline',
					title: 'Authorizations',
					link: '/authorizations',
					enabled: false
				},
				{
					icon: 'text-box-check-outline',
					title: 'Medical Review Guidelines',
					link: { app: 'interqual' },
					enabled: false
				},
				{
					icon: 'folder-edit-outline',
					title: 'Update Policy Info',
					link: '/', // saturated on mount
					enabled: false
				},
				{
					icon: 'open-in-new',
					title: 'Your Plan',
					link: '/', // saturated on mount
					enabled: false
				},
				{
					icon: 'transit-connection-variant',
					title: 'Coordination of Benefits',
					link: { app: 'cob' },
					enabled: false
				},
				{
					icon: 'airplane',
					title: 'Coverage when Traveling Abroad',
					link: '/traveling-abroad',
					enabled: false
				}
			] as NavLink[],
			memberId: '',
			startDate: '',
			planName: '',
			logoutClicked: false
		}
	},
	setup() {
		const { state, loaded } = storeToRefs(useAccessRightsStore())
		return { rightsStore: state, rightsLoaded: loaded }
	},
	async mounted() {
		if (this.rightsLoaded) {
			this.getUserAccess()
		}
	},
	methods: {
		setRightTitle(type: NavLink[], right: string, item: boolean | undefined) {
			const careLink = type.find((x) => x.title == right)
			if (careLink) careLink.enabled = !!item
		},
		setRightLink(type: NavLink[], right: string, item: boolean | undefined) {
			const careLink = type.find((x) => {
				if (typeof x.link === 'object') return x.link.app == right
				return x.link == right
			})
			if (careLink) careLink.enabled = !!item
		},
		getUserAccess() {
			const selectedPlan = useSelectedPlanStore().getStore()

			this.planSelected = true
			this.memberId = selectedPlan.memberId
			this.startDate = MMDDYYYY(selectedPlan.origEffDate)
			this.planName = selectedPlan.lobDisplayName

			// Care Links dropdown
			this.setRightTitle(this.careLinks, 'Claims', this.rightsStore?.claims)
			this.setRightTitle(this.careLinks, 'Explanation of Benefits', this.rightsStore?.claims)
			this.setRightTitle(this.careLinks, 'Spending Details', this.rightsStore?.deductible)
			this.setRightTitle(
				this.careLinks,
				'Personal Health Record',
				this.rightsStore?.personalHealthRecord
			)
			this.setRightTitle(
				this.careLinks,
				'Health Reimbursement Account',
				this.rightsStore?.healthReimbursementAccount
			)
			this.setRightLink(
				this.careLinks,
				'/find-care',
				!!this.rightsStore?.findCareAndCostOptions?.length &&
					this.rightsStore.findCareAndCostOptions.length > 0
			)
			this.setRightTitle(
				this.careLinks,
				'Preventive Wellness Services',
				this.rightsStore?.preventativeCare
			)
			const pharmacyLink = this.careLinks.find((x) => x.title == 'Pharmacy Spending')
			const hasWmProgram = checkCarrierCode(selectedPlan.carrierCode, 'walmart')
			if (pharmacyLink && hasWmProgram) pharmacyLink.enabled = true

			// Policy Links dropdown
			this.setRightTitle(
				this.policyLinks,
				'Coverage & Copays',
				this.rightsStore?.whosCovered && selectedPlan.contractType.toLowerCase() === 'medical'
			)
			this.setRightTitle(
				this.policyLinks,
				'Coverage & Benefits',
				this.rightsStore?.whosCovered && selectedPlan.contractType.toLowerCase() === 'dental'
			)
			this.setRightTitle(
				this.policyLinks,
				'Coverage',
				this.rightsStore?.whosCovered && selectedPlan.contractType.toLowerCase() === 'vision'
			)
			this.setRightTitle(
				this.policyLinks,
				'Primary Care Provider',
				this.rightsStore?.choosePrimaryCareProvider
			)
			this.setRightTitle(
				this.policyLinks,
				'Authorizations',
				this.rightsStore?.inpatientMedicalAdmissionRequest
			)
			this.setRightTitle(
				this.policyLinks,
				'Medical Review Guidelines',
				this.rightsStore?.pageIdentifiers?.some((x) => x.type == 'interqual')
			)
			this.setRightTitle(
				this.policyLinks,
				'Update Policy Info',
				this.rightsStore?.updatePolicy || this.rightsStore?.updatePolicyMetallic
			)
			this.setRightTitle(this.policyLinks, 'Your Plan', this.rightsStore?.maPlanBenefits)
			this.setRightTitle(
				this.policyLinks,
				'Coordination of Benefits',
				!!this.rightsStore?.updateOtherCoverageInformation
			)
			this.setRightTitle(
				this.policyLinks,
				'Coverage when Traveling Abroad',
				this.rightsStore?.coverageWhenTravelingAbroad
			)

			// additional link modifications
			const findCareItem = this.careLinks.find((x) => x.link == '/find-care')
			if (findCareItem?.title && this.rightsStore?.findCareAndCostDisplayText)
				findCareItem.title = this.rightsStore.findCareAndCostDisplayText

			const yourPlanLink = this.policyLinks.find((x) => x.title == 'Your Plan')
			if (yourPlanLink?.link && this.rightsStore?.maPlanBenefitsLink)
				yourPlanLink.link = this.rightsStore?.maPlanBenefitsLink

			const updatePolicyItem = this.policyLinks.find((x) => x.title == 'Update Policy Info')
			if (this.rightsStore?.updatePolicy && updatePolicyItem?.link) {
				updatePolicyItem.link = {
					app: 'updatepolicy'
				}
			} else if (this.rightsStore?.updatePolicyMetallic && updatePolicyItem?.link) {
				updatePolicyItem.link = {
					app: 'updatepolicymetallic'
				}
			}
		},
		toggleCareDropdown() {
			this.policyDropdown = false
			this.careDropdown = !this.careDropdown
		},
		togglePolicyDropdown() {
			this.careDropdown = false
			this.policyDropdown = !this.policyDropdown
		},
		routeTo(location: string | { app: string }) {
			if (typeof location == 'string') {
				if (location.includes('http')) {
					window.open(location, '_blank')
				} else {
					this.$router.push(location)
				}
				this.closeMenus()
			} else {
				const selectedPlan = useSelectedPlanStore().getStore()
				const body = JSON.stringify({
					app: location.app,
					userName: selectedPlan.username,
					companyId: selectedPlan.companyId,
					memberId: selectedPlan.memberId,
					contractType: selectedPlan.contractType,
					relayState: ''
				})

				ssoBridge(body)
			}
		},
		closeMenus() {
			this.careDropdown = false
			this.policyDropdown = false
			this.showDrawer = false
			this.showProfile = false
		},
		goToDashboard() {
			this.careDropdown = false
			this.policyDropdown = false
			this.showDrawer = false
			this.showProfile = false
		},
		async logoutUser() {
			if (document.querySelector('body')?.classList.contains('chat_started')) {
				Five9ChatTerminate()
			}
			await this.$router.push('/login')
			logout()
		},
		clickedLogout() {
			this.logoutClicked = true
			// check for pending changes, if none logout
			hasSignOutClicked().set(true)
			if (!hasPendingChanges().get()) {
				this.logoutUser()
			}
			// if has pending changes, set the composable to show that signout has been clicked
			// then the watcher in SettingsPreferences.vue and This file will handle it
		},
		maintainFocus() {
			this.showDrawer = !this.showDrawer
			setTimeout(() => {
				const menuItems = document.querySelectorAll('.links-container > *')
				const firstItem = menuItems[0]
				const lastItem = menuItems[menuItems.length - 1].lastChild

				// Cast firstChild to HTMLElement
				const firstChild = firstItem.firstChild as HTMLElement | null

				if (firstChild?.nodeType === 1) {
					firstChild.focus()

					firstChild.addEventListener('keydown', function (e) {
						if ((e as KeyboardEvent).shiftKey) {
							e.preventDefault()
						}
					})
				}

				if (lastItem) {
					lastItem.addEventListener('focus', function () {
						lastItem.addEventListener('keydown', function (e) {
							if ((e as KeyboardEvent).key === 'Tab') {
								firstChild?.focus()
								e.preventDefault()
							}
						})
					})
				}
			}, 100)
		},
		dropdownFocus(e: Event) {
			const targetItem = e.target as HTMLElement | null
			if (targetItem?.nextElementSibling) {
				const dropdownItems = targetItem.nextElementSibling.querySelectorAll('.dropdown > *')

				dropdownItems.forEach((element: Element) => {
					element.addEventListener('focus', () => {
						if (!element.nextElementSibling) {
							element.addEventListener('keydown', (event: Event) => {
								if ((event as KeyboardEvent).key === 'Tab') {
									if (element.parentElement) {
										element.parentElement.style.display = 'none' // ✅ was: .style = 'display: none;'
									}
									this.careDropdown = false
									this.policyDropdown = false
								}
							})
						}
					})
				})
			}
		}
	},
	computed: {
		greeting() {
			const today = new Date()
			return today.getHours() < 12
				? 'Good Morning'
				: today.getHours() < 17
					? 'Good Afternoon'
					: 'Good Evening'
		},
		showSwitchPlans() {
			const memberStore = useMembershipsStore().state
			const memberStoreLoaded = useMembershipsStore().loaded

			if (!memberStoreLoaded) return false
			return memberStore?.active?.length == 1 && memberStore?.inactive?.length < 1 ? false : true
		},
		dashBoardPath() {
			const selectedPlan = useSelectedPlanStore().getStore()
			if (selectedPlan.contractType == 'Medical') {
				return '/medical/dashboard'
			} else if (selectedPlan.contractType == 'Dental') {
				return '/dental/dashboard'
			} else if (selectedPlan.contractType == 'Vision') {
				return '/vision/dashboard'
			} else {
				return undefined
			}
		},
		displayName() {
			return useUserSettingsStore().displayName
		},
		confirmContinue() {
			// since this is options api we need to alias the composable value so we can watch it
			return confirmContinue.value
		}
	},
	watch: {
		rightsLoaded(newValue) {
			if (newValue) {
				if (this.rightsLoaded) {
					this.getUserAccess()
				}
			} else {
				this.planSelected = false
			}
		},
		displayName(newValue, oldValue) {
			if (newValue) this.displayName = newValue
		},
		confirmContinue(newValue, oldValue) {
			// watches for a value change and then triggers logout
			// this might be better to move outside of this file in the future
			if (!oldValue && newValue && hasSignOutClicked().get()) {
				hasSignOutClicked().set(false)
				this.logoutUser()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.v-container {
	background: white;
	max-width: 100%;
	padding: 0 var(--page-padding-inline, 32);
	margin-bottom: 0;
	border-bottom: 1px solid $neutral-200;

	@media print {
		display: none;
	}
}

.navbar {
	width: 100%;
	height: 80px;
	max-width: 1280px;
	margin: 0 auto;
	padding: 20px 0;
	display: flex;
	align-items: center;
	font-weight: 500;
	color: $neutral-600;
	flex-shrink: 1;

	&__logo {
		@media (width > 1200px) {
			margin-right: 20px;
		}

		@media (width > 1350px) {
			margin-right: 50px;
		}
	}

	.v-list-item {
		@media (width < 1200px) {
			padding: 4px 14px;
		}
	}

	.links-window {
		width: 100%;

		display: none;

		&.js-active {
			display: block;
		}

		@media (width > 1145px) {
			display: block;
		}
	}
}

a.v-list-item,
a.v-btn,
.v-list-item {
	color: $neutral-600;

	&:hover,
	&:focus {
		color: $neutral-900;

		:deep(.v-list-item__overlay) {
			--v-hover-opacity: 0.1;
		}
	}
}

.links-container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
.logo {
	height: 32px;
	width: 32px;
	cursor: pointer;
}

.close-menu {
	min-height: 32px;
}

.menu {
	cursor: pointer;
	padding: 0 16px;
}

.profile {
	position: relative;
}

.profile-btn {
	width: 40px !important;
	height: 40px !important;
	background: $neutral-200;
	border: 1px solid $neutral-300;
	border-radius: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.links {
	display: flex;
	gap: 4px;
	align-items: center;
}

.dropdown-link {
	position: relative;
}

.dropdown {
	position: absolute;
	top: 32px;
	left: -32px;
	background: white;
	color: $neutral-900;
	padding: 12px 0;
	border: 1px solid $neutral-200;
	border-radius: $radius-md;
	display: flex;
	flex-direction: column;
	width: 320px;
	box-shadow: $shadow-sm;
	z-index: 1;

	.v-list-item {
		padding: 16px 16px;
	}
	.v-icon {
		margin-right: 12px;
		color: $text-brand;
	}
}

:deep(.v-list-item__content:has(.custom-icon)) {
	display: flex;
	align-items: center;
}

.custom-icon {
	width: rem(24);
	height: rem(24);

	display: inline-flex;
	justify-content: center;
	align-items: center;

	margin: 0 12px 0 0;

	color: $text-brand;
}

.profile-panel {
	position: absolute;
	top: 44px;
	right: 0;
	display: flex;
	flex-direction: column;
	width: 208px;
	font-size: 14px;
	background: white;
	box-shadow: $shadow-sm;
	border: 1px solid $neutral-200;
	border-radius: $radius-sm;
	z-index: 1;

	.heading {
		display: flex;
		padding: 12px 16px;
		gap: 12px;
		border-bottom: 1px solid $neutral-200;
	}

	.body {
		padding: 12px 16px;
		background: $primary-50;
	}

	h4 {
		margin-bottom: 4px;
		font-size: 14px;
	}

	p:not([class*='font-weight']) {
		font-weight: 400;
	}

	.row {
		display: flex;
		gap: 4px;
	}

	.v-btn {
		justify-content: flex-start;
		border: none;
		font-size: 14px;
	}
}

@media only screen and (max-width: calc($large-glass + 1px)) {
	.navbar {
		justify-content: space-between;
		height: 72px;
		background: white;
	}

	.navbar--select {
		justify-content: flex-end;
	}

	.links-window {
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 9999;
		background: rgba($color: #000000, $alpha: 0.5);
		height: 100%;
	}

	.links-container {
		position: fixed;
		right: 0;
		display: block;
		background: white;
		height: 100%;
		width: 600px;
		max-width: 100%;
		overflow-y: auto;
		animation-name: fade-in;
		animation-duration: 0.15s;
		animation-timing-function: ease-out;

		.profile {
			margin: 24px 16px;

			.profile-btn {
				display: none;
			}
		}

		.fullsize {
			display: none;
			width: 100%;
		}

		.v-btn {
			margin-top: 16px;
		}
	}

	@keyframes fade-in {
		0% {
			transform: translateX(6%);
		}
		100% {
			transform: translateX(0%);
		}
	}

	.links {
		flex-direction: column;
		gap: 4px;
		padding-top: 24px;
		align-items: flex-start;
	}

	.dropdown {
		top: unset;
		left: 12px;
		background: $primary-50;
		gap: 0;
		margin-top: 20px;
	}

	.profile-panel {
		position: relative;
		top: unset;
		width: 100%;
		box-shadow: none;
		font-size: 16px;
		border: 1px solid $primary-200;
		z-index: 0;

		h4 {
			font-size: 20px;
		}

		.body {
			padding: 16px 24px;
			border-radius: $radius-sm;
		}

		p {
			width: 120px;
		}

		.v-btn {
			font-size: 16px;
		}
	}

	body:has(.v-overlay--active) {
		.links-window {
			z-index: 2399;
		}
	}
}
</style>
